import { type Message } from "@/shared/reader";
import { type TopicData } from "@/shared/state/visualization";

import styles from "./NoRecordedDataMessage.module.css";

interface NoRecordedDataMessageProps {
  isLoading: boolean;
  message: Message | null;
  panelData: TopicData[];
}

/**
 * Shown when data paths are configured but the playback position is before
 * the earliest recorded message (the only case where `message` is null
 * while paths exist — latest-at semantics cover all later timestamps).
 */
export function NoRecordedDataMessage({
  isLoading,
  message,
  panelData,
}: NoRecordedDataMessageProps) {
  if (isLoading || message !== null || panelData.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      No recorded messages at this point in the timeline
    </div>
  );
}
